import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  iconButton2nzpucy7a6ixd as iconButton,
  reactiveLabel206b3aonybuoa as reactiveLabel,
  addButton16duilic9iyqp as addButton,
  emptyRow1djlr0t4x675n as emptyRow,
} from '../components/view-utilities.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  BannerSemantic_getInstance18p0b4btg61q8 as BannerSemantic_getInstance,
  LinkSemantic_getInstance292trrvb33tue as LinkSemantic_getInstance,
  styledHeaderwng1nfqibdig as styledHeader,
} from '../../theme/semantics.mjs';
import {
  text189ciz0cnr32o as text,
  subtext2yjmf1ok7kb40 as subtext,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  get_atEnd34105oxxaxc2o as get_atEnd,
  get_centered31th09q7x90sf as get_centered,
  get_atStart2tusd7ehy6hjj as get_atStart,
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  addLocationRateDialogykpwmkgv3k40 as addLocationRateDialog,
  addAttendancePeriodDialogtbnknfp2bbke as addAttendancePeriodDialog,
  addClosureDialogmoz60sf1yaca as addClosureDialog,
  editClosureDialog19dt1cpachlxe as editClosureDialog,
  locationFormhh7qfpr9thx as locationForm,
} from './locationComponents.mjs';
import { LocationRatePagecks6xwyzxx95 as LocationRatePage } from '../rates/LocationRatePage.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  ID3j2ictjlq95nd as ID,
  ID3lnbkn76l7dgd as ID_0,
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { AttendancePeriodDetailPage2fnxdkx3t2m6k as AttendancePeriodDetailPage } from '../attendance/AttendancePeriodDetailPage.mjs';
import { ChildPlacementDetailPagewfmc55i6s15v as ChildPlacementDetailPage } from '../children/ChildPlacementDetailPage.mjs';
import { get_entries2ar453qbk297a as get_entries } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  distinct10qe1scfdvu5k as distinct,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  today1rno4frfjp5oe as today,
  nowLocal2mdv5rmil2cf2 as nowLocal,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import {
  ID1z61wlmtvxrjn as ID_1,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  LocationAttendancePeriod3bx3r7kkwecs9 as LocationAttendancePeriod,
  CareLocationClosure1da03s5ze3kft as CareLocationClosure,
  ID1m87d1hextx54 as ID_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Draft3goc8q7vggbic as Draft } from '../../extensions/Draft.ext.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  get_notNull2od35hy6ssmdh as get_notNull,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_location2f1azencio7x2 as get_location,
  get_location1p3um6ao7ento as get_location_0,
  get_activeRangedsifhrs4gcfc as get_activeRange,
  get_start30tbw38mnjak0 as get_start,
  get_endInclusive2wh7ub8763o5h as get_endInclusive,
  get_locationrgfu4uek4c14 as get_location_1,
  get_submitted382abp2i1n972 as get_submitted,
  get_approved221jlb71nbap0 as get_approved,
  get_periodnytt0bk9l5et as get_period,
  get_start1ib7kl469eh9c as get_start_0,
  get_location5qvftw9oaw3d as get_location_2,
  get_date13hdmf8teioql as get_date,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  eq353yrgcpovoi1 as eq,
  lte2qmhlnwrclg8p as lte,
  gte1zw995v5ulf70 as gte,
  lt30kf68e33bhtj as lt,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  and3dbt2f202um49 as and,
  or1uh2qn0k1rz6c as or,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { contains5fsvztcdjo1e as contains } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dateRangeConditions.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import {
  plus1oi9f9vif99u2 as plus,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { ProviderDetailPagemo61e65yggj8 as ProviderDetailPage } from '../providers/ProviderDetailPage.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq as PhoneNumber__toString_impl_7i2x3q,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from '../reports/SingleDaysPage.mjs';
import { ReportFiltersigb451dg4asm as ReportFilters } from '../reports/ReportFilters.mjs';
import { PlacementTotalsPage1pmi1f9h9gb4a as PlacementTotalsPage } from '../reports/PlacementTotalsPage.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  table1wgqnzrzsmc0y as table,
  tablezpetcq9vbay1 as table_0,
} from '../components/table.mjs';
import { AttendancePeriodsListPagekcmctzhabmp9 as AttendancePeriodsListPage } from '../attendance/AttendancePeriodsListPage.mjs';
import { AttendancePeriodFilters2ya4mm5gzi7ou as AttendancePeriodFilters } from '../attendance/AttendancePeriodFilters.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, LocationDetailPage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, LocationDetailPage$actionBar$slambda($this));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, LocationDetailPage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Save location', VOID, VOID, VOID, VOID, VOID, LocationDetailPage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function LocationDetailPage$location$lambda($this$Draft) {
  return $this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
}
function LocationDetailPage$isAdmin$lambda($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function LocationDetailPage$render$slambda$lambda($this$dialog, close) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = sizeConstraints($this$dialog, get_standardDialogWidth());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  // Inline function 'com.lightningkite.kiteui.views.warning' call
  var this_1 = themed(element, BannerSemantic_getInstance());
  var tmp$ret$5 = themed(this_1, WarningSemantic_getInstance());
  text(tmp$ret$5, 'Feature still under development');
  subtext(element, 'Check box \u2013 closed to new enrollment (enrollment freeze) due to sanctions set by EEC possibly');
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Separator())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = get_atEnd(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_3.willAddChild_hz2iwc_k$(element_1);
  text(element_1, 'Close');
  onClick(element_1, VOID, VOID, VOID, LocationDetailPage$render$slambda$lambda$slambda(close));
  element_1.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function LocationDetailPage$render$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function LocationDetailPage$render$slambda($$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, LocationDetailPage$render$slambda$lambda);
    return Unit_instance;
  }), 0);
}
function LocationDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationDetailsSectionTitle_d2wrk9_k$();
}
function LocationDetailPage$render$lambda_0($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationEditButton_aysohy_k$();
}
function LocationDetailPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function LocationDetailPage$render$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationProviderLabel_b4amqt_k$();
}
function LocationDetailPage$render$lambda_2($this$reactiveLabel) {
  return 'Type';
}
function LocationDetailPage$render$lambda_3($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddressSectionTitle_ooy4vd_k$();
}
function LocationDetailPage$render$lambda_4($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactNameLabel_3ysqd5_k$();
}
function LocationDetailPage$render$lambda_5($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactEmailLabel_efzqw6_k$();
}
function LocationDetailPage$render$lambda_6($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactPhoneLabel_4m2zrc_k$();
}
function LocationDetailPage$render$lambda_7($this$styledHeader) {
  return 'Reports';
}
function LocationDetailPage$render$lambda_8($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationRatesHeading_uw7hbn_k$();
}
function LocationDetailPage$render$lambda_9($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddRateButton_ve9lbf_k$();
}
function LocationDetailPage$render$lambda$slambda_0(this$0, $this_addButton) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $this_addButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.location_1;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    addLocationRateDialog(this$0, tmp, tmp$ret$0);
    return Unit_instance;
  }), 0);
}
function LocationDetailPage$render$lambda_10(it) {
  return new (LocationRatePage())(it._id_1);
}
function LocationDetailPage$render$lambda_11($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationPrototypeColumnLabel_7abp2e_k$();
}
function LocationDetailPage$render$lambda_12($this$text, it) {
  return it.name_1;
}
function LocationDetailPage$render$lambda_13($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationPlanLabel_xccdpp_k$();
}
function LocationDetailPage$render$lambda_14($this$text, it) {
  var tmp0_$this = $this$text.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProgramTemplates_ojj53j_k$();
  var tmp1_id = it.template_1;
  // Inline function 'kotlin.time.Companion.minutes' call
  Companion_getInstance_0();
  var tmp2_pullFrequency = toDuration(10, DurationUnit_MINUTES_getInstance());
  // Inline function 'kotlin.time.Companion.minutes' call
  Companion_getInstance_0();
  var tmp3_maximumAge = toDuration(10, DurationUnit_MINUTES_getInstance());
  var tmp4_safe_receiver = $this$text.invoke_r7m7el_k$(tmp0_$this.item_eropyg_k$(new (ID())(tmp1_id), tmp3_maximumAge, tmp2_pullFrequency));
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.name_1;
  return tmp5_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationUnknownPlanLabel_i0kgn5_k$() : tmp5_elvis_lhs;
}
function LocationDetailPage$render$lambda_15($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateOnThisPlanSinceLabel_vdwh5j_k$();
}
function LocationDetailPage$render$lambda_16($this$text, it) {
  return renderToString(it.templateSince_1, RenderSize_Abbreviation_getInstance());
}
function LocationDetailPage$render$lambda_17($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAttendanceHeading_qbmfph_k$();
}
function LocationDetailPage$render$lambda_18($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddAttendancePeriodButton_2ztszj_k$();
}
function LocationDetailPage$render$lambda$slambda_1($this_addButton, this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $this_addButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.location_1;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    addAttendancePeriodDialog(tmp, tmp$ret$0);
    return Unit_instance;
  }), 0);
}
function LocationDetailPage$render$lambda_19($this$colOf, period) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  var this_0 = themed($this$colOf, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_1 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_2 = weight(this_1, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).attendancePeriodPageTitle_p6ycjf_k$($this$invoke.invoke_r7m7el_k$(period).period_1.toString()));
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_3 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_3.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(period).submitted_1 == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationPeriodNotSubmittedStatus_xdso1l_k$() : $this$invoke.invoke_r7m7el_k$(period).approved_1 == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationPeriodNeedsApprovalStatus_1q9c99_k$() : '');
  element_2.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = Link$_get_to_$ref_jq7esp(element);
  var tmp_7 = getPropertyCallableRef('to', 0, tmp_5, tmp_6, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_7, ($this$invoke) => () => new (AttendancePeriodDetailPage())($this$invoke.invoke_r7m7el_k$(period)._id_1));
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function LocationDetailPage$render$lambda_20($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationActivePlacementsSectionTitle_nw2pyz_k$();
}
function LocationDetailPage$render$lambda_21(it) {
  return new (ChildPlacementDetailPage())(it._id_1);
}
function LocationDetailPage$render$lambda_22($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationChildColumnLabel_8ikusg_k$();
}
function LocationDetailPage$render$lambda_23($this$text, it) {
  return it.childName_1;
}
function LocationDetailPage$render$lambda_24($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationRateColumnLabel_aaazvk_k$();
}
function LocationDetailPage$render$lambda_25($this$text, placement) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_entries();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp0_safe_receiver = placement.schedule_1.get_riprg6_k$(element);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.program_1;
    var tmp0_safe_receiver_0 = tmp == null ? null : new (ID_0())(tmp);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.add_utx5q5_k$(tmp0_safe_receiver_0);
    }
  }
  var tmp_0 = distinct(destination);
  return joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, (id) => {
    var tmp0_safe_receiver = $this$text.invoke_r7m7el_k$($this$text.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationPrograms_g0oima_k$().get_6ueaa7_k$(id));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationUnknownRateLabel_ltp6qw_k$() : tmp1_elvis_lhs;
  });
}
function LocationDetailPage$render$lambda_26($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationActiveDatesColumnLabel_f4guo3_k$();
}
function LocationDetailPage$render$lambda_27($this$text, it) {
  var tmp0_safe_receiver = it.activeRange_1.endInclusive_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver, RenderSize_Abbreviation_getInstance());
  var end = tmp1_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationNoEndDateLabel_1tfruy_k$() : tmp1_elvis_lhs;
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).locationDateRange_w0af9i_k$(renderToString(it.activeRange_1.start_1, RenderSize_Abbreviation_getInstance()), end);
}
function LocationDetailPage$render$lambda_28($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAgreementStatusColumnLabel_dddsdc_k$();
}
function LocationDetailPage$render$lambda_29($this$text, it) {
  var tmp = $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance()));
  var tmp0_safe_receiver = it.signingInfo_1;
  return tmp.signatureStatusLabel_agp5cg_k$(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.status_1);
}
function LocationDetailPage$render$lambda_30($this$styledHeader) {
  return 'Closures ' + today().year_1;
}
function LocationDetailPage$render$lambda_31($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddClosureButton_djcbau_k$();
}
function LocationDetailPage$render$lambda$slambda_2(this$0, $this_addButton) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $this_addButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.location_1;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    addClosureDialog(this$0, tmp, listOf(tmp$ret$0));
    return Unit_instance;
  }), 0);
}
function LocationDetailPage$render$lambda$slambda_3(this$0, $$this$button, $current) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = (yield* await_0(this_0, $completion)).isAdmin_1;
    if (yield* await_0(this_1, $completion)) {
      var tmp_0 = $$this$button.get_context_h02k06_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $current;
      var tmp_1 = yield* await_0(this_2, $completion);
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_3 = this$0.location_1;
      var tmp$ret$3 = yield* await_0(this_3, $completion);
      editClosureDialog(this$0, tmp_0, tmp_1, tmp$ret$3);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
function LocationDetailPage$render$lambda_32($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureDateLabel_yxq7hz_k$();
}
function LocationDetailPage$render$lambda_33($this$text, it) {
  return renderToString(it.date_1, RenderSize_Abbreviation_getInstance());
}
function LocationDetailPage$render$lambda_34($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureKindColumnLabel_l2ckur_k$();
}
function LocationDetailPage$render$lambda_35($this$text, it) {
  return it.reason_1.displayName_1 + ' \xB7 ' + (it.reason_1.paid_1 ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closurePaidLabel_brac2y_k$() : $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closureUnpaidLabel_5pnjh9_k$());
}
function LocationDetailPage$render$lambda_36($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function LocationDetailPage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function LocationDetailPage$actionBar$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.location_1.cancel_2l89ey_k$();
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    return Unit_instance;
  }), 0);
}
function LocationDetailPage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationSaveButton_pcmeoj_k$();
}
function LocationDetailPage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.location_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    yield* this$0.location_1.publish_xq9q2e_k$($completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp$ret$2 = yield* await_1(this_1, $completion);
    toast(tmp_0, tmp$ret$2.get_locationSavedToast_9rc1s2_k$());
    return Unit_instance;
  }), 1);
}
var LocationDetailPageClass;
function LocationDetailPage() {
  if (LocationDetailPageClass === VOID) {
    class $ extends Form() {
      constructor(id) {
        super();
        this.id_1 = id;
        var tmp = this;
        tmp.location_1 = validated(Draft(new (ID_1())(this.id_1), LocationDetailPage$location$lambda));
        var tmp_0 = this;
        tmp_0.rates_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationPrograms_g0oima_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$3);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          var tmp$ret$4 = eq(get_location(it), new (ID_1())(this.id_1));
          var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
        });
        var tmp_1 = this;
        tmp_1.placements_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var now = nowLocal().get_date_wokkxj_k$();
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$13 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$13);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$14 = and(and(eq(get_location_0(it), new (ID_1())(this.id_1)), lte(get_start(get_activeRange(it)), now)), or(eq(get_endInclusive(get_activeRange(it)), null), gte(get_notNull(get_endInclusive(get_activeRange(it))), now)));
          var tmp$ret$10 = new (Query())(tmp$ret$14, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$10));
        });
        var tmp_2 = this;
        tmp_2.attendancePeriods_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var now = nowLocal().get_date_wokkxj_k$();
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_locationAttendancePeriods_kbvlcb_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
          var tmp$ret$22 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$22);
          var tmp_1 = and(eq(get_location_1(it), new (ID_1())(this.id_1)), or(or(eq(get_submitted(it), null), eq(get_approved(it), null)), contains(get_period(it), now)));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
          var tmp$ret$29 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$29);
          this_0.ascending_ijynum_k$(get_start_0(get_period(it_0)));
          var tmp$ret$25 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$25)));
        });
        var tmp_3 = this;
        tmp_3.closures_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var now = nowLocal().get_date_wokkxj_k$();
          var yearFromNow = plus(now, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(1));
          var startOfYear = LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(now.year_1, 1, 1);
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationClosures_im9skn_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocationClosure()), arrayOf([]), false));
          var tmp$ret$33 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$33);
          var tmp_1 = and(and(eq(get_location_2(it), new (ID_1())(this.id_1)), gte(get_date(it), startOfYear)), lt(get_date(it), yearFromNow));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(CareLocationClosure()), arrayOf([]), false));
          var tmp$ret$40 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$40);
          this_0.ascending_ijynum_k$(get_date(it_0));
          var tmp$ret$36 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$36)));
        });
        var tmp_4 = this;
        tmp_4.isAdmin_1 = remember(VOID, VOID, VOID, VOID, LocationDetailPage$isAdmin$lambda);
        var tmp_5 = this;
        tmp_5.managesLocation_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.let' call
          var it = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
          return $this$remember.invoke_r7m7el_k$(it.managedLocations_1).contains_aljjnj_k$(new (ID_1())(this.id_1)) || $this$remember.invoke_r7m7el_k$(it.managedProviders_1).contains_aljjnj_k$(new (ID_2())($this$remember.invoke_r7m7el_k$(this.location_1).provider_1));
        });
        this.editMode_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).locationDetailTitle_rl62c8_k$($this$remember.invoke_r7m7el_k$(this.location_1).name_1));
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.location_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_4 = shownWhen(element_0, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_5 = themed(this_4, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Button())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_5.willAddChild_hz2iwc_k$(element_2);
        text(element_2, 'Pause enrollment');
        onClick(element_2, VOID, VOID, VOID, LocationDetailPage$render$slambda(element_2));
        element_2.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_2);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_6 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_6.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_7 = themed(element_3, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_7.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(element_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        element_4.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_8 = get_centered(element_5);
        var tmp$ret$33 = weight(this_8, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_9 = get_bold(tmp$ret$33);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_9.willAddChild_hz2iwc_k$(element_6);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_6);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_6));
        element_6.invoke_bnq13k_k$(tmp_4, LocationDetailPage$render$lambda);
        element_6.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_6);
        var tmp_5 = get_centered(element_5);
        var tmp_6 = shownWhen(tmp_5, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(this.managesLocation_1));
        var tmp_7 = get_edit(Companion_getInstance_1());
        var tmp_8 = LocationDetailPage$render$lambda_0;
        iconButton(tmp_6, tmp_7, tmp_8, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, LocationDetailPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        element_5.onStartup_vrxh3i_k$();
        element_4.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(element_4.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_4.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = weight(element_7, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_10.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_8.willAddChild_hz2iwc_k$(element_9);
        var tmp_9 = KMutableProperty0();
        var tmp_10 = LabeledView$_get_content_$ref_5yojet(element_9);
        var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, LabeledView$_set_content_$ref_ys1c8f(element_9));
        element_9.invoke_bnq13k_k$(tmp_11, LocationDetailPage$render$lambda_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_11 = themed(get_atStart(element_9), LinkSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (Link())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_11.willAddChild_hz2iwc_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(element_10.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_10.willAddChild_hz2iwc_k$(element_11);
        var tmp_12 = KMutableProperty0();
        var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_14, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.location_1).providerName_1);
        element_11.onStartup_vrxh3i_k$();
        element_10.addChild_2qpft2_k$(element_11);
        var tmp_15 = KMutableProperty0();
        var tmp_16 = Link$_get_to_$ref_jq7esp(element_10);
        var tmp_17 = getPropertyCallableRef('to', 0, tmp_15, tmp_16, Link$_set_to_$ref_i9gu5x(element_10));
        element_10.invoke_bnq13k_k$(tmp_17, ($this$invoke) => () => new (ProviderDetailPage())($this$invoke.invoke_r7m7el_k$(this.location_1).provider_1));
        element_10.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_10);
        element_9.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_9);
        var tmp_18 = LocationDetailPage$render$lambda_2;
        reactiveLabel(element_8, tmp_18, ($this$reactiveLabel) => $this$reactiveLabel.invoke_r7m7el_k$(this.location_1).type_1.displayName_1);
        var tmp_19 = LocationDetailPage$render$lambda_3;
        reactiveLabel(element_8, tmp_19, ($this$reactiveLabel) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$reactiveLabel.invoke_r7m7el_k$(this.location_1).address_1.toString();
          var tmp;
          if (isBlank(this_0)) {
            tmp = '[Not set]';
          } else {
            tmp = this_0;
          }
          return tmp;
        });
        element_8.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (Separator())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element_7.willAddChild_hz2iwc_k$(element_12);
        element_12.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_12 = weight(element_7, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_12.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(true);
        var tmp_20 = LocationDetailPage$render$lambda_4;
        reactiveLabel(element_13, tmp_20, ($this$reactiveLabel) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$reactiveLabel.invoke_r7m7el_k$(this.location_1).contact_1.name_1;
          var tmp;
          if (isBlank(this_0)) {
            tmp = '[Not set]';
          } else {
            tmp = this_0;
          }
          return tmp;
        });
        var tmp_21 = LocationDetailPage$render$lambda_5;
        reactiveLabel(element_13, tmp_21, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.location_1).contact_1.email_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = EmailAddress__toString_impl_artjh3(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '[Not set]' : tmp1_elvis_lhs;
        });
        var tmp_22 = LocationDetailPage$render$lambda_6;
        reactiveLabel(element_13, tmp_22, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.location_1).contact_1.phone_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '[Not set]' : tmp1_elvis_lhs;
        });
        element_13.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_13);
        element_7.onStartup_vrxh3i_k$();
        element_4.addChild_2qpft2_k$(element_7);
        element_4.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = shownWhen(element_3, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(this.managesLocation_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_13.willAddChild_hz2iwc_k$(element_14);
        element_14.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Space())(element_14.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        element_14.willAddChild_hz2iwc_k$(element_15);
        element_15.onStartup_vrxh3i_k$();
        element_14.addChild_2qpft2_k$(element_15);
        styledHeader(element_14, LocationDetailPage$render$lambda_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (RowOrCol())(element_14.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        element_14.willAddChild_hz2iwc_k$(element_16);
        element_16.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_14 = themed(element_16, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (Link())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        this_14.willAddChild_hz2iwc_k$(element_17);
        text(element_17, 'Billed days');
        var tmp_23 = KMutableProperty0();
        var tmp_24 = Link$_get_to_$ref_jq7esp(element_17);
        var tmp_25 = getPropertyCallableRef('to', 0, tmp_23, tmp_24, Link$_set_to_$ref_i9gu5x(element_17));
        element_17.invoke_bnq13k_k$(tmp_25, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (SingleDaysPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, VOID, VOID, setOf(new (ID_1())(this.id_1))));
          return this_0;
        });
        element_17.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_15 = themed(element_16, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (Link())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_15.willAddChild_hz2iwc_k$(element_18);
        text(element_18, 'Enrollment');
        var tmp_26 = KMutableProperty0();
        var tmp_27 = Link$_get_to_$ref_jq7esp(element_18);
        var tmp_28 = getPropertyCallableRef('to', 0, tmp_26, tmp_27, Link$_set_to_$ref_i9gu5x(element_18));
        element_18.invoke_bnq13k_k$(tmp_28, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (PlacementTotalsPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, VOID, VOID, setOf(new (ID_1())(this.id_1))));
          return this_0;
        });
        element_18.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_18);
        element_16.onStartup_vrxh3i_k$();
        element_14.addChild_2qpft2_k$(element_16);
        element_14.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (Space())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        element_3.willAddChild_hz2iwc_k$(element_19);
        element_19.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_19);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (RowOrCol())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        element_3.willAddChild_hz2iwc_k$(element_20);
        element_20.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_16 = get_atBottomStart(element_20);
        var tmp_29 = weight(this_16, 1.0);
        styledHeader(tmp_29, LocationDetailPage$render$lambda_8);
        var tmp_30 = get_centered(element_20);
        var tmp_31 = shownWhen(tmp_30, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1));
        var tmp_32 = LocationDetailPage$render$lambda_9;
        addButton(tmp_31, tmp_32, ($this$addButton) => {
          onClick($this$addButton, VOID, VOID, VOID, LocationDetailPage$render$lambda$slambda_0(this, $this$addButton));
          return Unit_instance;
        });
        element_20.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_20);
        var tmp_33 = LocationDetailPage$render$lambda_10;
        var tmp_34 = Companion_instance_0;
        var tmp_35 = LocationDetailPage$render$lambda_11;
        var tmp_36 = tmp_34.text_y5ktm4_k$(tmp_35, 1.0, LocationDetailPage$render$lambda_12);
        var tmp_37 = Companion_instance_0;
        var tmp_38 = LocationDetailPage$render$lambda_13;
        var tmp_39 = tmp_37.text_y5ktm4_k$(tmp_38, 2.0, LocationDetailPage$render$lambda_14);
        var tmp_40 = Companion_instance_0;
        var tmp_41 = LocationDetailPage$render$lambda_15;
        table(element_3, this.rates_1, tmp_33, [tmp_36, tmp_39, tmp_40.text_y5ktm4_k$(tmp_41, 1.0, LocationDetailPage$render$lambda_16)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_17 = shownWhen(element_3, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(this.managesLocation_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (RowOrCol())(this_17.get_context_h02k06_k$());
        ensureOutermostElement(element_21);
        this_17.willAddChild_hz2iwc_k$(element_21);
        element_21.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_22 = new (Space())(element_21.get_context_h02k06_k$());
        ensureOutermostElement(element_22);
        element_21.willAddChild_hz2iwc_k$(element_22);
        element_22.onStartup_vrxh3i_k$();
        element_21.addChild_2qpft2_k$(element_22);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_23 = new (RowOrCol())(element_21.get_context_h02k06_k$());
        ensureOutermostElement(element_23);
        element_21.willAddChild_hz2iwc_k$(element_23);
        element_23.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_18 = get_atBottomStart(element_23);
        var tmp_42 = weight(this_18, 1.0);
        styledHeader(tmp_42, LocationDetailPage$render$lambda_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_19 = themed(get_centered(element_23), LinkSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_24 = new (Link())(this_19.get_context_h02k06_k$());
        ensureOutermostElement(element_24);
        this_19.willAddChild_hz2iwc_k$(element_24);
        text(element_24, 'View past attendance');
        var tmp_43 = KMutableProperty0();
        var tmp_44 = Link$_get_to_$ref_jq7esp(element_24);
        var tmp_45 = getPropertyCallableRef('to', 0, tmp_43, tmp_44, Link$_set_to_$ref_i9gu5x(element_24));
        element_24.invoke_bnq13k_k$(tmp_45, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (AttendancePeriodsListPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (AttendancePeriodFilters())(VOID, VOID, VOID, VOID, setOf(new (ID_1())(this.id_1))));
          return this_0;
        });
        element_24.onStartup_vrxh3i_k$();
        this_19.addChild_2qpft2_k$(element_24);
        var tmp_46 = get_centered(element_23);
        var tmp_47 = LocationDetailPage$render$lambda_18;
        addButton(tmp_46, tmp_47, ($this$addButton) => {
          onClick($this$addButton, VOID, VOID, VOID, LocationDetailPage$render$lambda$slambda_1($this$addButton, this));
          return Unit_instance;
        });
        element_23.onStartup_vrxh3i_k$();
        element_21.addChild_2qpft2_k$(element_23);
        emptyRow(shownWhen(element_21, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.attendancePeriods_1).isEmpty_y1axqb_k$()));
        colOf(element_21, this.attendancePeriods_1, VOID, VOID, VOID, LocationDetailPage$render$lambda_19);
        element_21.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_21);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_20 = shownWhen(element_3, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(this.managesLocation_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_25 = new (RowOrCol())(this_20.get_context_h02k06_k$());
        ensureOutermostElement(element_25);
        this_20.willAddChild_hz2iwc_k$(element_25);
        element_25.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_26 = new (Space())(element_25.get_context_h02k06_k$());
        ensureOutermostElement(element_26);
        element_25.willAddChild_hz2iwc_k$(element_26);
        element_26.onStartup_vrxh3i_k$();
        element_25.addChild_2qpft2_k$(element_26);
        styledHeader(element_25, LocationDetailPage$render$lambda_20);
        var tmp_48 = LocationDetailPage$render$lambda_21;
        var tmp_49 = Companion_instance_0;
        var tmp_50 = LocationDetailPage$render$lambda_22;
        var tmp_51 = tmp_49.text$default_gwb2zv_k$(tmp_50, VOID, LocationDetailPage$render$lambda_23);
        var tmp_52 = Companion_instance_0;
        var tmp_53 = LocationDetailPage$render$lambda_24;
        var tmp_54 = tmp_52.text$default_gwb2zv_k$(tmp_53, VOID, LocationDetailPage$render$lambda_25);
        var tmp_55 = Companion_instance_0;
        var tmp_56 = LocationDetailPage$render$lambda_26;
        var tmp_57 = tmp_55.text$default_gwb2zv_k$(tmp_56, VOID, LocationDetailPage$render$lambda_27);
        var tmp_58 = Companion_instance_0;
        var tmp_59 = LocationDetailPage$render$lambda_28;
        table(element_25, this.placements_1, tmp_48, [tmp_51, tmp_54, tmp_57, tmp_58.text$default_gwb2zv_k$(tmp_59, VOID, LocationDetailPage$render$lambda_29)]);
        element_25.onStartup_vrxh3i_k$();
        this_20.addChild_2qpft2_k$(element_25);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_21 = shownWhen(element_3, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(this.managesLocation_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_27 = new (RowOrCol())(this_21.get_context_h02k06_k$());
        ensureOutermostElement(element_27);
        this_21.willAddChild_hz2iwc_k$(element_27);
        element_27.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_28 = new (Space())(element_27.get_context_h02k06_k$());
        ensureOutermostElement(element_28);
        element_27.willAddChild_hz2iwc_k$(element_28);
        element_28.onStartup_vrxh3i_k$();
        element_27.addChild_2qpft2_k$(element_28);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_29 = new (RowOrCol())(element_27.get_context_h02k06_k$());
        ensureOutermostElement(element_29);
        element_27.willAddChild_hz2iwc_k$(element_29);
        element_29.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_22 = get_atBottomStart(element_29);
        var tmp_60 = weight(this_22, 1.0);
        styledHeader(tmp_60, LocationDetailPage$render$lambda_30);
        var tmp_61 = get_centered(element_29);
        var tmp_62 = shownWhen(tmp_61, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1));
        var tmp_63 = LocationDetailPage$render$lambda_31;
        addButton(tmp_62, tmp_63, ($this$addButton) => {
          onClick($this$addButton, VOID, VOID, VOID, LocationDetailPage$render$lambda$slambda_2(this, $this$addButton));
          return Unit_instance;
        });
        element_29.onStartup_vrxh3i_k$();
        element_27.addChild_2qpft2_k$(element_29);
        var tmp_64 = ($this$table, current) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Button())($this$table.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$table.willAddChild_hz2iwc_k$(element);
          element.set_action_2ds022_k$(Action('Detail', VOID, VOID, VOID, VOID, VOID, LocationDetailPage$render$lambda$slambda_3(this, element, current)));
          element.onStartup_vrxh3i_k$();
          $this$table.addChild_2qpft2_k$(element);
          return element;
        };
        var tmp_65 = Companion_instance_0;
        var tmp_66 = LocationDetailPage$render$lambda_32;
        var tmp_67 = tmp_65.text$default_gwb2zv_k$(tmp_66, VOID, LocationDetailPage$render$lambda_33);
        var tmp_68 = Companion_instance_0;
        var tmp_69 = LocationDetailPage$render$lambda_34;
        table_0(element_27, this.closures_1, tmp_64, [tmp_67, tmp_68.text$default_gwb2zv_k$(tmp_69, VOID, LocationDetailPage$render$lambda_35)]);
        element_27.onStartup_vrxh3i_k$();
        this_21.addChild_2qpft2_k$(element_27);
        element_3.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_23 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_30 = new (RowOrCol())(this_23.get_context_h02k06_k$());
        ensureOutermostElement(element_30);
        this_23.willAddChild_hz2iwc_k$(element_30);
        element_30.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_31 = new (Separator())(element_30.get_context_h02k06_k$());
        ensureOutermostElement(element_31);
        element_30.willAddChild_hz2iwc_k$(element_31);
        element_31.onStartup_vrxh3i_k$();
        element_30.addChild_2qpft2_k$(element_31);
        actionBar(this, element_30);
        locationForm(this, element_30, this.location_1, true);
        actionBar(this, element_30);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_32 = new (Separator())(element_30.get_context_h02k06_k$());
        ensureOutermostElement(element_32);
        element_30.willAddChild_hz2iwc_k$(element_32);
        element_32.onStartup_vrxh3i_k$();
        element_30.addChild_2qpft2_k$(element_32);
        element_30.onStartup_vrxh3i_k$();
        this_23.addChild_2qpft2_k$(element_30);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_24 = shownWhen(element, VOID, VOID, LocationDetailPage$render$lambda_36);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_33 = new (Space())(this_24.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_33);
        this_24.willAddChild_hz2iwc_k$(element_33);
        element_33.onStartup_vrxh3i_k$();
        this_24.addChild_2qpft2_k$(element_33);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'LocationDetailPage', VOID, VOID, [Page(), CanBlockBack()]);
    LocationDetailPageClass = $;
  }
  return LocationDetailPageClass;
}
//region block: exports
export {
  LocationDetailPage as LocationDetailPage2zka4ek7qyuhq,
};
//endregion

//# sourceMappingURL=LocationDetailPage.mjs.map
